import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ChevronRight, FileText, Shield } from "lucide-react";

const SettingsLegal = () => {
  const navigate = useNavigate();

  const items = [
    { icon: FileText, label: "Privacy Notice", path: "/privacy" },
    { icon: Shield, label: "Terms of Use", path: "/terms" },
  ];

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-10 border-b border-border/50 bg-background/80 backdrop-blur-sm">
        <div className="mx-auto flex max-w-2xl items-center gap-3 px-4 md:px-6 py-4">
          <Button variant="ghost" size="icon" onClick={() => navigate("/settings")} aria-label="Back">
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div>
            <h1 className="text-page-title text-foreground">Legal</h1>
            <div className="mt-0.5 h-0.5 w-10 rounded-full bg-accent" />
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-2xl px-4 md:px-6 py-8 animate-fade-in">
        <div className="space-y-3">
          {items.map((item, index) => (
            <button
              key={item.label}
              onClick={() => navigate(item.path)}
              style={{ animationDelay: `${index * 80}ms` }}
              className="flex w-full items-center gap-3 card-premium p-5 transition-shadow hover:shadow-md animate-fade-in"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent/10">
                <item.icon className="h-5 w-5 text-accent" />
              </div>
              <p className="flex-1 text-left font-medium text-foreground">{item.label}</p>
              <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground/50" />
            </button>
          ))}
        </div>
      </main>
    </div>
  );
};

export default SettingsLegal;
